
export default {
    name: 'Error404',
    props: {
        backURL: String,
    },
    computed: {
        backCTAURL() {
            return this.backURL || '/';
        },
    },
};
